import {
  CandidatesCv,
  CandidatesTrack,
  CandidatesPersonal,
  CandidatesEmployment,
  CandidatesCommunication,
  WeeklyAssignment,
} from "./CandidatesTableContents";
import CandidateSkillSection from "../../components/CandidateForm/CandidateSkillSection";
import CandidateWorkingPattern from "../../components/CandidateForm/CandidateWorkingPattern";
import HolidayTable from "../../components/CandidateForm/Holiday";
import {
  Description as CvIcon,
  Timeline as TrackIcon,
  Chat as CommunicationIcon,
  Person as PersonalIcon,
  Folder as DocumentIcon,
  Work as EmploymentIcon,
  Psychology as SkillsIcon,
  Schedule as PatternIcon,
  BeachAccess as HolidayIcon,
  Security as RbacIcon,
} from "@mui/icons-material";
import DocumentView from "./CandidatesTableContents/CandidatesDocument";

export const CandidateTabHeaders = [
  {
    id: 1,
    title: "CV",
    eventKey: "cv",
    icon: <CvIcon sx={{ fontSize: 18 }} />,
    component: ({ clickedId }) => <CandidatesCv clickedId={clickedId} />,
    isDisable: false,
  },
  {
    id: 2,
    title: "TRACK",
    eventKey: "track",
    icon: <TrackIcon sx={{ fontSize: 18 }} />,
    component: ({ clickedId }) => <CandidatesTrack clickedId={clickedId} />,
    isDisable: true,
  },
  {
    id: 3,
    title: "COMMUNICATION",
    eventKey: "communication",
    icon: <CommunicationIcon sx={{ fontSize: 18 }} />,
    component: ({ clickedId }) => (
      <CandidatesCommunication clickedId={clickedId} />
    ),
    isDisable: true,
  },
  {
    id: 4,
    title: "PERSONAL",
    eventKey: "personal",
    icon: <PersonalIcon sx={{ fontSize: 18 }} />,
    component: ({ clickedId }) => <CandidatesPersonal clickedId={clickedId} />,
    isDisable: false,
  },
  {
    id: 5,
    title: "DOCUMENT",
    eventKey: "document",
    icon: <DocumentIcon sx={{ fontSize: 18 }} />,
    component: ({ clickedId }) => <DocumentView clickedId={clickedId} />,
    isDisable: false,
  },
  {
    id: 6,
    title: "EMPLOYMENT",
    eventKey: "employment",
    icon: <EmploymentIcon sx={{ fontSize: 18 }} />,
    component: ({ clickedId }) => (
      <CandidatesEmployment clickedId={clickedId} />
    ),
    isDisable: false,
  },
  {
    id: 7,
    title: "SKILLS",
    eventKey: "skills",
    icon: <SkillsIcon sx={{ fontSize: 18 }} />,
    component: ({ clickedId }) => (
      <CandidateSkillSection clickedId={clickedId} />
    ),
    isDisable: false,
  },
  {
    id: 8,
    title: "WORKING PATTERN",
    eventKey: "pattern",
    icon: <PatternIcon sx={{ fontSize: 18 }} />,
    component: ({ clickedId }) => (
      <CandidateWorkingPattern clickedId={clickedId} />
    ),
    isDisable: false,
  },
  {
    id: 9,
    title: "HOLIDAY",
    eventKey: "holiday",
    icon: <HolidayIcon sx={{ fontSize: 18 }} />,
    component: ({ clickedId }) => (
      <HolidayTable candidateId={clickedId} />
    ),
    isDisable: false,
  },
  {
    id: 10,
    title: "Weekly Assignment",
    eventKey: "weekly-assignment",
    icon: <RbacIcon sx={{ fontSize: 18 }} />,
    component: ({ clickedId }) => (
      <WeeklyAssignment candidateId={clickedId} />
    ),
    isDisable: false,
  },
];